<div class="bg-[#FAFAFA] rounded-[20px] p-4 sm:p-6 space-y-6">

    <!-- PAGE HEADER -->
    <div class="flex items-center justify-between w-full">
        <h1 class="text-xl sm:text-xl font-semibold text-[#444A6D]">
            {{ 'SETUP.GUARANTOR_SETUP.TITLE' | translate }}
        </h1>
        <button class="bg-indigo-600 text-white text-sm px-4 py-2 rounded-lg" (click)="openGuarantor()">
            {{ 'SETUP.GUARANTOR_SETUP.ADD_BUTTON' | translate }}
        </button>
    </div>

    <!-- =========================
                            GUARANTOR TABLE
                    =========================== -->
    <div class=" ">
        <div class="">
            <app-table [columns]="columns" [data]="guarantors" [actions]="actions" [enablePagination]="true" >
            </app-table>
        </div>
    </div>
</div>
<!-- Popup Modal -->
<app-popup [title]="popupTitle" [fields]="popupFields" [onSave]="SaveGuarantor.bind(this)" [show]="showPopup"
    [type]="isDeleteConfirm ? 'confirm' : 'form'" [message]="deleteMessage" [readonly]="isViewMode"
    (showChange)="showPopup = $event" (confirmed)="onDeleteConfirmed()">
</app-popup>
